__turbopack_context__.v({
  "body": "AttachmentChip-module__d9l1Nq__body",
  "chip": "AttachmentChip-module__d9l1Nq__chip",
  "chip-shimmer": "AttachmentChip-module__d9l1Nq__chip-shimmer",
  "filename": "AttachmentChip-module__d9l1Nq__filename",
  "iconWrap": "AttachmentChip-module__d9l1Nq__iconWrap",
  "meta": "AttachmentChip-module__d9l1Nq__meta",
  "removeButton": "AttachmentChip-module__d9l1Nq__removeButton",
  "shimmer": "AttachmentChip-module__d9l1Nq__shimmer",
  "thumb": "AttachmentChip-module__d9l1Nq__thumb",
});
